import Vue from 'vue';
import App from './App.vue';
import Vant from 'vant';
import 'vant/lib/index.css';
import router from './router';
import http from './http';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import common from './common/function'
import 'swiper/swiper-bundle.css'
import store from './store'
import VueI18n from 'vue-i18n';
import { Icon } from 'vant';
import 'video.js/dist/video-js.css'
import VueCookies from 'vue-cookies'
Vue.prototype.$http = http
Vue.prototype.common = common
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(Vant);
Vue.use(Icon);
Vue.use(VueI18n);
Vue.use(VueCookies)
const i18n = new VueI18n({
  globalInjection: true, 
  locale: localStorage.getItem("lang") || "en", // 动态获取语言设置，默认为日语
  messages: {
    'zh': require('./assets/languages/zh.json'),
    'en': require('./assets/languages/en.json'),
    'ja': require('./assets/languages/ja.json'),
	'de': require('./assets/languages/de.json'),
	'fr': require('./assets/languages/fr.json'),
	'es': require('./assets/languages/es.json'),
	'it': require('./assets/languages/it.json'),
	'ru': require('./assets/languages/ru.json'),
    'kr': require('./assets/languages/kr.json')
  }
});
window.$i18n = i18n; 
new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
